import React, { forwardRef, useLayoutEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import type { ReactRefT } from '@src/types/misc';
import styled from '@emotion/styled';
import useDisableUserSelect from '@src/hooks/useDisableUserSelect';

type TRef = ReactRefT<HTMLElement>;

type TProps = {
  triggerRef: TRef;
  selectedColor: string;
  onChange: (color: string) => void;
};
const PickerContainer = styled.div((props: { left: number }) => ({
  left: props.left,
  position: 'absolute',
  zIndex: 1
}));

const PICKER_WIDTH = 180;
const PICKER_PADDING = 10;
const WIDTH = PICKER_WIDTH + PICKER_PADDING * 2;

const ColorPicker = forwardRef(function ColorPicker(props: TProps, ref: React.MutableRefObject<HTMLDivElement>) {
  const [left, setLeft] = useState(0);
  useDisableUserSelect();

  useLayoutEffect(() => {
    const rect = props.triggerRef.current.getBoundingClientRect();

    setLeft(props.triggerRef.current.offsetLeft + rect.width - WIDTH);
  }, [props.triggerRef]);

  return (
    <PickerContainer ref={ref} left={left}>
      <SketchPicker
        color={props.selectedColor}
        disableAlpha
        width={PICKER_WIDTH.toString()}
        onChange={(color) => props.onChange(color.hex)}
      />
    </PickerContainer>
  );
});

export default ColorPicker;
